<template>
  <div v-if="record" class="order-detail">
    <section class="section">
      <!-- ACTIONS -->
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <router-link to="/releases"  class="navbar-item">
              <span class="mdi mdi-chevron-left"></span>&nbsp; All Releases
            </router-link>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <div class="field has-addons">
              <div class="control" v-if="remainingCount > 0">
                 <button class="button" @click="assignUnit()">
                   <span class="icon icon-medium"><i class="mdi mdi-file-replace-outline mdi-18px"></i></span>
                   <span>Assign</span>
                 </button>
              </div>
              <div v-if="remainingCount > 0" class="control">
                <button class="button" @click="gateOut({ product: record.product })">
                  <span class="icon icon-medium"><i class="mdi mdi-clipboard-arrow-up-outline mdi-18px"></i></span>
                  <span>Gate Out</span>
                </button>
              </div>
              <template v-if="record.transfer">
                <div class="control">
                  <router-link :to="{ name: 'transfer', params: { id: record.transfer.id }}" data-attribute="transfer.reference">
                    <button class="button">
                      <span class="icon icon-medium"><i class="mdi mdi-clipboard-flow mdi-18px"></i></span>
                      <span>View <span class="is-hidden-mobile">Transfer</span></span>
                    </button>
                  </router-link>
                </div>
              </template>
              <div class="control">
                <button class="button" @click="editRecord()">
                  <span class="icon icon-medium"><i class="mdi mdi-file-document-edit-outline mdi-18px"></i></span>
                  <span>Edit</span>
                </button>
              </div>
              <div class="control" v-if="is_admin && !record.transfer">
                <button class="button"  @click="deleteRecord()">
                  <span class="icon icon-medium"><i class="mdi mdi-delete-forever-outline mdi-18px"></i></span>
                  <span>Delete</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="box is-relative">
        <order-status :record="record" />
        <div class="columns">

          <div class="column is-narrow">
            <p class="heading">Release Number</p>
            <h4 class="title is-4">{{ record.reference }}</h4>
          </div>
          <div class="column is-narrow">
            <p class="heading">Product Code</p>
            <h5 v-if="record.product" class="title is-5" data-attribute="product.code">{{ record.product.code }}</h5>
          </div>
          <div class="column is-narrow" v-if="record.data && record.data.purchase_order">
            <p class="heading">Order Number</p>
            <h5 class="title is-5" data-attribute="data.purchase-order">{{ record.data.purchase_order }}</h5>
          </div>
          <div class="column is-narrow">
            <div class="level is-mobile">
              <div class="level-item">
                <div class="has-text-centered">
                  <p class="heading">Total</p>
                  <h5 class="title is-5"><span data-attribute="total-count" >{{ record.unit_count }}</span></h5>
                </div>
              </div>

              <div class="level-item">
                <div class="has-text-centered">
                  <p class="heading">Assigned</p>
                  <h5 class="title is-5"><span data-attribute="assigned-count">{{ record.order_units.length }}</span></h5>
                </div>
              </div>

              <div class="level-item">
                <div class="has-text-centered">
                  <p class="heading">Delivered</p>
                  <h5 class="title is-5"><span data-attribute="delivered-count">{{ deliveredCount }}</span></h5>
                </div>
              </div>

              <div class="level-item">
                <div class="has-text-centered">
                 <p class="heading">Remaining</p>
                 <h5 class="title is-5"><span data-attribute="remaining-count">{{ remainingCount }}</span></h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-table">
          <div class="table-wrapper">
            <table class="table is-striped is-narrow has-mobile-cards is-inbox">

              <tr>
                <th class="is-hidden-mobile" style="width: 150px;">
                   Depot:
                </th>
                <td data-label="Depot:">
                  <span class="tag" data-attribute="depot.name">
                    {{ record.depot.name }}
                  </span>
                </td>
              </tr>

              <tr v-if="record.color">
                <th class="is-hidden-mobile" style="width: 150px;">
                  Color:
                </th>
                <td data-label="Color:">
                  <span v-if="record.color" class="color-swatch-wrapper">
                    <span class="color-swatch" :class="record.color | colorClassName"></span>
                    <span data-attribute="color">{{ record.color }}</span>
                  </span>
                </td>
              </tr>

              <tr>
                <th class="is-hidden-mobile" style="width: 150px;">
                  Expected:
                </th>
                <td data-label="Expected:">
                  <span data-attribute="expected-at">{{ record.expected_at | formattedDate }}</span>
                </td>
              </tr>

              <tr>
                <th class="is-hidden-mobile" style="width: 150px;">
                  Expired:
                </th>
                <td data-label="Expired:">
                  <span v-if="record.expires_at" data-attribute="expires-at">{{ record.expires_at | formattedDate }}</span><span v-else>N/A</span>
                </td>
              </tr>

              <tr>
                <th class="is-hidden-mobile" style="width: 150px;">
                  Created By:
                </th>
                <td data-label="Expired:">
                  <span v-if="record.created_by_user" data-attribute="created-by-user">
                    {{ record.created_by_user.first_name }}
                    {{ record.created_by_user.last_name }}
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div class="box">
        <h6 class="title is-6">Notes</h6>
        <div class="pre-wrapper">
          <pre data-attribute="notes">{{ record.notes }}</pre>
        </div>
      </div>

      <div class="box">
        <order-unit-table :records="record.order_units" @gateOut="gateOut" @edit="editOrderUnit" @delete="deleteOrderUnit" />
      </div>

    </section>
  </div>

  <loader v-else />

</template>

<script>
  import { mapState } from 'vuex'
  import filters from 'shared/filters'

  import UserHelper from 'shared/mixins/user-helper'
  import AsyncRecord from 'shared/mixins/async-record'
  import OrderUnitActions from '../../mixins/order-unit-actions'

  import Loader from 'shared/components/loader'
  import OrderStatus from './status'
  import OrderUnitTable from '../outgoing-order-units/table'
  import OrderUnitForm from '../outgoing-order-units/form'
  // import GateOutForm from '../outgoing-order-units/gate-out-form'
  import OrderForm from './form'

  export default {
    filters,
    mixins: [ UserHelper, AsyncRecord, OrderUnitActions ],
    components: {
      Loader,
      OrderStatus,
      OrderUnitTable
    },
    data () {
      return {
        orderUnitForm: OrderUnitForm,
        asyncRecordOptions: {
          type: 'order',
          options: {
            order_type: 'incoming',
            include: [
              'depot',
              'transfer',
              'created_by_user',
              'product',
              'order_units.unit.product'
            ].join(',')
          }
        }
      }
    },
    computed: {
      deliveredCount () {
        if (!this.record) return 0
        return this.record.order_units.filter(i => i.released_at).length
      },
      remainingCount () {
        if (!this.record) return 0
        return parseInt(this.record.unit_count) - this.deliveredCount
      }
    },
    methods: {
      editRecord () {
        this.$buefy.modal.open({
          parent: this,
          component: OrderForm,
          props: {
            record: { ...this.record },
            onSave: record => {
              this.fetchRecord()
            }
          }
        })
      },
      deleteRecord () {
        this.$buefy.dialog.confirm({
          title: 'Deleting Release',
          message: 'Are you sure you want to <b>delete</b> this release?',
          confirmText: 'Delete Release',
          type: 'is-danger',
          onConfirm: () => {
            this.$store.dispatch('deleteRecord', [ 'order', this.record ]).then(() => {
              this.$router.push('/releases')
            })
          }
        })
      }
    }
  }
</script>
